'use client';

import { useTranslations } from 'next-intl';

export default function GuideModeToggleButton({
  onClick,
  active = false,
  label,
  activeLabel,
  inactiveLabel,
  className = '',
}) {
  const t = useTranslations('OnboardingTour');

  const fallbackLabel = active
    ? (activeLabel || t('close'))
    : (inactiveLabel || t('guideButton'));

  return (
    <button
      type="button"
      onClick={onClick}
      className={`rounded-xl border px-3 py-2 text-sm font-semibold transition ${
        active
          ? 'border-cyan-400/60 bg-cyan-500/15 text-cyan-200'
          : 'border-slate-700 bg-slate-900/70 text-slate-200 hover:border-slate-500'
      } ${className}`}
    >
      {label || fallbackLabel}
    </button>
  );
}



